import ReactPDF, { View, Text, StyleSheet } from "@react-pdf/renderer";
import { Resume, SectionConfig } from "jobjump-types/Resume";
import React from "react";
import { ResumeSectionProp, DocumentGrid, DocumentCell, OrderedResumeSections } from "./CommonSections";

const PersonalDetailsSection = 
<Style extends ReactPDF.Styles>({resume:{personal_details}, style} : Omit<ResumeSectionProp<Style>, "sectionConfig">) => {
    return <View style={style.sectionStyle}>
        <Text style={{...style.heading1, marginBottom:"16px"}}>{personal_details.name}</Text>
        {personal_details.address && personal_details.address !== "" && 
            <Text style={style.smallText}>Address: {personal_details.address}</Text>}
        <DocumentGrid>
            {personal_details.email && personal_details.email !== "" && 
                <DocumentCell size={6}><Text style={style.smallText}>Email: {personal_details.email}</Text></DocumentCell>}
            {personal_details.phone && personal_details.phone !== "" && 
                <DocumentCell size={6}><Text style={style.smallText}>Phone: {personal_details.phone}</Text></DocumentCell>}
            {personal_details.other?.map(o =>
                o.value !== "" && <DocumentCell size={6}><Text style={style.smallText}>{o.key}: {o.value}</Text></DocumentCell>
            )}
        </DocumentGrid>
        {personal_details.languages && personal_details.languages !== "" && 
            <Text style={style.smallText}>Languages Spoken: {personal_details.languages}</Text>}
    </View>
}

type SectionProps<T extends ReactPDF.Styles> = {
    section: SectionConfig,
    defaultTitle: string,
    style: T,
}

const Section : React.FC<SectionProps<{heading1:any}>> = ({section, defaultTitle, style, children}) =>
    <View wrap={section.name === "employment_details"}>
        <Text style={style.heading1}>{section.alias || defaultTitle}</Text>
        {children}
    </View>

const MinimalResume : React.FC<{resume:Resume}> = ({resume}) => {
    const style = StyleSheet.create({
        page: {
            padding: "32px 32px 32px 32px",
            fontSize: "12pt",
            lineHeight: "1.5",
            fontFamily: resume.styleConfig.font !== "" ? resume.styleConfig.font : undefined
        },
        heading1: {
            fontSize: "22pt",
            borderBottom: `1px solid ${resume.styleConfig.primaryColor}`,
            color: resume.styleConfig.primaryColor 
        },
        heading2: {
            fontSize: "16pt",
        },
        smallText: {
            fontSize: "10pt",
        },
        sectionStyle: {
            paddingTop: "16px",
            paddingBottom: "16px",
        }
    })
    return <OrderedResumeSections resume={resume} style={style} SectionComponent={Section} />;
}

export default MinimalResume;